export default {
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  status: state => state.status,
  filterBy: state => state.filterBy,
  integrations: state => state.integrations,
  integration: state => state.integration,
  totalIntegrations: state => state.totalIntegrations
}



// WEBPACK FOOTER //
// ./src/store/modules/integrations/getters.js